import { ProcessingProgress } from '@/components/ProcessingProgress'
import { Card, CardContent } from '@/components/ui/card'
import { usePing } from '@/hooks/usePing'
import { useRef, type ReactNode } from 'react'
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs'

interface AppLayoutProps {
  children: ReactNode
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const { isLoading } = usePing()
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const { breadcrumbs } = useBreadcrumbs()

  return (
    <div className="flex flex-1 flex-col h-screen overflow-hidden mt-16 pb-16">
      <div
        ref={scrollContainerRef}
        data-scroll-container
        className="@container/main flex flex-1 flex-col overflow-y-auto"
      >
        <div className="container mx-auto flex flex-col pt-2 pb-16 max-w-[1600px]">
          {/* Breadcrumbs section */}
          {breadcrumbs && (
            <div className="flex items-center h-10 pl-9 transition-colors duration-200">
              <div className="container mx-auto max-w-[1600px]">
                {breadcrumbs}
              </div>
            </div>
          )}
          <div
            className={`container mx-auto flex flex-col gap-4 px-3 md:gap-6 max-w-[1600px] ${breadcrumbs ? 'pt-4' : 'pt-8'}`}
          >
            {isLoading ? (
              <Card>
                <CardContent>
                  <ProcessingProgress message="Loading" />
                </CardContent>
              </Card>
            ) : (
              <>{children}</>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
